import { LeagueConfig, Environment } from "@leagueplatform/core";
import { APP_ID, TENANT_ID } from "common/constants";
import { LoadingSpinner } from "components/loading-spinner/loading-spinner.component";
import EN_LOCALES from "locales/en.json";
import ES_LOCALES from "locales/es.json";
import FR_LOCALES from "locales/fr.json";
import { EAPTheme } from "theme/theme";

const {
  VITE_SEGMENT_KEY,
  VITE_WS_API_URL,
  VITE_API_URL,
  VITE_LEGACY_REST_API_URL,
  VITE_CONTENT_URL,
  VITE_AUTH0_DOMAIN,
  VITE_AUTH0_CLIENT_ID,
  VITE_APP_ENV,
  VITE_APP_CLIENT_ID,
  VITE_AUTH0_AUDIENCE,
  VITE_AUTH0_CONNECTION,
} = import.meta.env;

console.log("VITE_APP_ENV", VITE_APP_ENV);

const authConfig = {
  domain: VITE_AUTH0_DOMAIN!,
  client_id: VITE_AUTH0_CLIENT_ID!,
  redirect_uri: window.location.origin,
  audience: VITE_AUTH0_AUDIENCE!,
  connection: VITE_AUTH0_CONNECTION!,
};

const analyticsConfig = {
  segmentKey: VITE_SEGMENT_KEY,
};

const apiConfig = {
  wsUrl: VITE_WS_API_URL!,
  url: VITE_API_URL!,
  legacyRestApi: VITE_LEGACY_REST_API_URL!,
};

const customMethodsConfig = {
  handleLink: async (url: string) => {
    await window.open(url, "_blank", "noreferrer");
  },
};

export const config: LeagueConfig = {
  core: {
    clientId: VITE_APP_CLIENT_ID || APP_ID,
    tenantId: TENANT_ID,
    auth: { clientOptions: authConfig, idleSessionLifetimeHours: 0.25 }, // Default 15 minutes, should match the auth0 session inactivity timeout
    analytics: analyticsConfig,
    api: apiConfig,
    appEnvironment: VITE_APP_ENV as Environment,
    contentUrl: VITE_CONTENT_URL!,
    routing: { isUsingLeagueRouting: true },
    customMethods: customMethodsConfig,
    ui: {
      theme: EAPTheme,
      components: {
        pageHeader: {
          shape: "line",
        },
        loading: {
          element: <LoadingSpinner />,
          text: false,
        },
      },
    },
    i18n: {
      strings: {
        default: EN_LOCALES,
        en: EN_LOCALES,
        es: ES_LOCALES,
        fr: FR_LOCALES,
      },
    },
  },
  careDiscovery: {
    masonryAppVersion: "2.0",
    masonryAppId: {
      left: "careLandingPage$root",
    },
  },
  __internal: {
    shouldApplyCSSReset: true,
    shouldApplyLegacyGlobalStyles: true,
    shouldIgnoreDOMLangAttributeForLocale: true,
  },
};
